exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__Grid___3A-vq{padding-left:0;padding-right:0}", ""]);

// Exports
exports.locals = {
	"Grid": "styles__Grid___3A-vq"
};